export const fontSize = (font, id, text, clientWidth) => {
	let textSize = 70
	let inputRow = document.getElementById(id)
	inputRow.innerText = text

	inputRow.style.fontFamily = font
	let textContainer = document.getElementById('textBox')
	for (let i = textSize;i >= 0;i--) {
		let overflow = () => {
			return inputRow.scrollHeight > textContainer.scrollHeight || inputRow.scrollWidth > (clientWidth ? clientWidth : inputRow.clientWidth)
		}
		if (overflow()) {
			textSize--
		}

		inputRow.style.fontSize = `${textSize}px`
		inputRow.style.lineHeight = `${textSize + 3}px`
	}

	return textSize
}

export const renderUrl = (firstText, secondText, thirdText, chosenImage, chosenBackground, chosenFont, chosenFontColor, showSvg, showIllustration, type, setRenderedUrl) => {
	let safeColor = (chosenFontColor || '').replace('#', '') || '000000'
	let urlObject = {
		one: encodeURIComponent(firstText || ''),
		two: encodeURIComponent(secondText || ''),
		three: encodeURIComponent(thirdText || ''),
		background: chosenBackground || '',
		font: encodeURIComponent(chosenFont || ''),
		color: safeColor,
		type: type,
		showIllustration: showIllustration === true || showIllustration === 'ja' || showIllustration === 'true'
	}

	if (showSvg && chosenImage) {
		urlObject.svg = chosenImage
	}

	let urlString = JSON.stringify(urlObject)
	setRenderedUrl(urlString)
}